var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_title",class:{dark_mode: _vm.darkMode}},[_vm._t("default"),_c('span',[_vm._v(_vm._s(_vm.subtext))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }